(function (window, document) {
  "use strict";
  var $sk_reviews_grid_holder;
  var env_urls = skGetEnvironmentUrls("google-reviews");
  var app_url = env_urls.app_url;
  var sk_app_url = env_urls.sk_app_url;
  var app_backend_url = env_urls.app_backend_url;
  var sk_api_url = env_urls.sk_api_url;
  var app_file_server_url = env_urls.app_file_server_url;
  var sk_img_url = env_urls.sk_img_url;
  var data_storage;
  var data_bio;
  var last_key = 0;
  var current_position = 0;
  var original_data;
  var additional_error_messages = [];
  var splide = null;
  var max_slides = 3;
  var el = document.getElementsByClassName("sk-ww-google-reviews")[0];
  if (el == undefined) {
	var el = document.getElementsByClassName("dsm-ww-fb-page-reviews")[0];
	el.className = "sk-ww-google-reviews";
  }
  let rippleSrc = "//www.bulletproofhitches.com/cdn/shop/t/69/assets/ripple.svg?v=178008052634062955251763135526";
  el.innerHTML = "<div class='first_loading_animation' style='text-align:center; width:100%;'><img loading='lazy' src='"+rippleSrc+"' class='loading-img' alt='Loading animation' width='88' height='88' style='width:auto !important;' /></div>";

  function loadCssFile(filename) {
	var fileref = document.createElement("link");
	fileref.setAttribute("rel", "stylesheet");
	fileref.setAttribute("type", "text/css");
	fileref.setAttribute("href", filename);
	if (typeof fileref != "undefined") {
	  document.getElementsByTagName("head")[0].appendChild(fileref);
	}
  }
  scriptLoadHandler();

  function scriptLoadHandler() {
	loadScript("//www.bulletproofhitches.com/cdn/shop/t/69/assets/moment.min.js?v=134129563950853884271763135522", function () {
	  var version = jQuery.fn.jquery;
	  version = version ? parseInt(version.charAt(0)) : 4;
	  main();
	});


  }
  function loadScript(url, callback) {
	var scriptTag = document.createElement("script");
	scriptTag.setAttribute("type", "text/javascript");
	scriptTag.setAttribute("src", url);
	scriptTag.setAttribute("async", "async");
	if (typeof callback !== "undefined") {
	  if (scriptTag.readyState) {
		scriptTag.onreadystatechange = function () {
		  if (this.readyState === "complete" || this.readyState === "loaded") {
			callback();
		  }
		};
	  } else {
		scriptTag.onload = callback;
	  }
	}
	(document.getElementsByTagName("head")[0] || document.documentElement).appendChild(scriptTag);
  }
  function getDsmEmbedId(sk_google_reviews) {
	var embed_id = sk_google_reviews.attr("embed-id");
	if (embed_id == undefined) {
	  embed_id = sk_google_reviews.attr("data-embed-id");
	}
	return embed_id;
  }
  function getDsmSetting(sk_google_reviews, key) {
	return sk_google_reviews.find("." + key).text();
  }
  function moderateData(sk_google_reviews, reviews) {
	if (getDsmSetting(sk_google_reviews, "order_by") == 2) {
	  reviews.sort(() => Math.random() - 0.5);
	}
	return reviews;
  }
  function applyDateFormat(sk_facebook_feed, data_storage) {
	var date_format = getDsmSetting(sk_facebook_feed, "date_format");
	var use_24_hour_clock = getDsmSetting(sk_facebook_feed, "use_24_hour_clock");
	var timezone = getDsmSetting(sk_facebook_feed, "timezone");
	var show_time_posted = getDsmSetting(sk_facebook_feed, "show_time_posted");
	var format = "MMM D, YYYY";
	if (date_format == "M d, Y") {
	  format = "MMM D, YYYY";
	} else if (date_format == "jS M Y") {
	  format = "Do MMM YYYY";
	} else if (date_format == "Y M jS") {
	  format = "YYYY MMM Do";
	} else if (date_format == "Y-m-d") {
	  format = "YYYY-MM-D";
	} else if (date_format == "m/d/Y") {
	  format = "MM/D/YYYY";
	} else if (date_format == "d/m/Y") {
	  format = "D/MM/YYYY";
	} else if (date_format == "d.m.Y") {
	  format = "D.MM.YYYY";
	} else if (date_format == "d-m-Y") {
	  format = "D-MM-YYYY";
	}
	if (use_24_hour_clock == 1 && show_time_posted == 1) {
	  format = format + " HH:mm";
	} else if (show_time_posted == 1) {
	  format = format + " hh:mm A";
	}
	jQuery.each(data_storage, function (index, value) {
	  if (data_storage[index] && data_storage[index].review_date_time) {
		var date_time = data_storage[index].review_date_time;
		try {
		  if (timezone) {
			data_storage[index].review_date_time = date_format == "time_ago" ? moment(date_time).fromNow() : moment(date_time).format(format);
		  } else {
			data_storage[index].review_date_time = date_format == "time_ago" ? moment(date_time).fromNow() : moment(date_time).format(format);
		  }
		} catch (error) {
		  data_storage[index].review_date_time = date_format == "time_ago" ? moment(date_time).fromNow() : moment(date_time).format(format);
		}
	  }
	});
	return data_storage;
  }
  function moderationTabFeature(data, sk_facebook_reviews) {
	var preapproved_albums = getDsmSetting(sk_facebook_reviews, "preapproved_posts");
	var excluded_albums = getDsmSetting(sk_facebook_reviews, "excluded_posts");
	var preapproved_posts = "do_not_show_anything";
	var excluded_posts = "";
	if (getDsmSetting(sk_facebook_reviews, "turnon_preapproval_posts") == 1) {
	  preapproved_posts = preapproved_albums;
	}
	if (excluded_albums != "") {
	  excluded_posts = excluded_albums;
	}
	var new_posts_list = [];
	if (data && data) {
	  for (let item of data) {
		if (typeof item != "undefined") {
		  if (getDsmSetting(sk_facebook_reviews, "turnon_preapproval_posts") == 1) {
			if (preapproved_posts.indexOf(item.contributor_id) != -1) {
			  new_posts_list.push(item);
			}
		  } else {
			if (getDsmSetting(sk_facebook_reviews, "turnon_preapproval_posts") == 0 && excluded_posts.indexOf(item.contributor_id) != -1) {
			} else {
			  new_posts_list.push(item);
			}
		  }
		}
	  }
	}
	return new_posts_list;
  }
  function showByRating(data, sk_facebook_reviews) {
	var show_5_star_rating = getDsmSetting(sk_facebook_reviews, "show_5_star_rating") == 1 ? "5" : "";
	var show_4_star_rating = getDsmSetting(sk_facebook_reviews, "show_4_star_rating") == 1 ? "4" : "";
	var show_3_star_rating = getDsmSetting(sk_facebook_reviews, "show_3_star_rating") == 1 ? "3" : "";
	var show_2_star_rating = getDsmSetting(sk_facebook_reviews, "show_2_star_rating") == 1 ? "2" : "";
	var show_1_star_rating = getDsmSetting(sk_facebook_reviews, "show_1_star_rating") == 1 ? "1" : "";
	var ratings = show_5_star_rating + show_4_star_rating + show_3_star_rating + show_2_star_rating + show_1_star_rating;
	var new_posts_list = [];
	if (data) {
	  for (let item of data) {
		if (typeof item != "undefined") {
		  if (show_5_star_rating || show_4_star_rating || show_3_star_rating || show_2_star_rating || show_1_star_rating) {
			item.rating = item.rating && item.rating == "5/5" ? "5" : item.rating;
			item.rating = item.rating && item.rating == "4/5" ? "4" : item.rating;
			item.rating = item.rating && item.rating == "3/5" ? "3" : item.rating;
			item.rating = item.rating && item.rating == "2/5" ? "2" : item.rating;
			item.rating = item.rating && item.rating == "1/5" ? "1" : item.rating;
			if (ratings.indexOf(item.rating) != -1) {
			  new_posts_list.push(item);
			}
		  }
		}
	  }
	}
	return new_posts_list;
  }
  function showWithTextOnly(data, sk_google_reviews) {
	var show_rating_with_text_only = getDsmSetting(sk_google_reviews, "show_rating_with_text_only");
	var gives_text = getDsmSetting(sk_google_reviews, "gives_text");
	var stars_rating_text = getDsmSetting(sk_google_reviews, "stars_rating_text");
	var new_posts_list = [];
	if (data) {
	  for (let item of data) {
		if (typeof item != "undefined") {
		  if (show_rating_with_text_only == 1) {
			if (item.review_text != "") {
			  new_posts_list.push(item);
			}
		  } else {
			if (item.review_text == "") {
			  item.review_text = item.reviewer_name + " " + gives_text + " " + data_bio.name + " " + item.rating + " " + stars_rating_text;
			}
			new_posts_list.push(item);
		  }
		}
	  }
	}
	return new_posts_list;
  }
  function sortReviewsBy(data, sk_facebook_reviews) {
	var order_by = "0";
	var new_posts_list = [];
	if (data) {
	  switch (order_by) {
		case "0":
		  data.sort(function (a, b) {
			return new Date(b.review_date_time).getTime() - new Date(a.review_date_time).getTime();
		  });
		  break;
		case "1":
		  data.sort(function (a, b) {
			return b.rating - a.rating;
		  });
		  break;
		case "2":
		  data = shuffle(data);
		  break;
		case "3":
		  data.sort(function (a, b) {
			return b.review_text.length - a.review_text.length;
		  });
		  break;
		default:
	  }
	  for (let item of data) {
		if (typeof item != "undefined") {
		  new_posts_list.push(item);
		}
	  }
	}
	return new_posts_list;
  }
  function shuffle(array) {
	let currentIndex = array.length,
		randomIndex;
	while (currentIndex != 0) {
	  randomIndex = Math.floor(Math.random() * currentIndex);
	  currentIndex--;
	  [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
	}
	return array;
  }
  function formatNumber(num) {
	return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  function loadFeed(sk_google_reviews) {
	var data = original_data;
	var embed_id = getDsmEmbedId(sk_google_reviews);
	var show_load_more_button = sk_google_reviews.find(".show_load_more_button").text();
	var show_average_rating = getDsmSetting(sk_google_reviews, "show_average_rating");
	if (sk_google_reviews.find(".sk-ww-google-reviews-items").length > 0) {
	  return;
	}
	var load_more_posts_text = sk_google_reviews.find(".load_more_posts_text").text();
	if (original_data.user_info && !widgetValidation(sk_google_reviews, original_data)) {
	  return;
	} else if (!original_data || !original_data.bio) {
	  generateSolutionMessage(sk_google_reviews, embed_id);
	  return;
	} else if (data.bio && data.bio.place_id != "" && data.bio.place_id != undefined) {
	  var post_items = "";
	  if (data.reviews && data.reviews.length) {
		data.reviews = moderateData(sk_google_reviews, data.reviews);
	  }
	  data_bio = data.bio;
	  data_storage = data.reviews;
	  data_storage = showByRating(data.reviews, sk_google_reviews);
	  data_storage = moderationTabFeature(data_storage, sk_google_reviews);
	  data_storage = showWithTextOnly(data_storage, sk_google_reviews);
	  data_storage = sortReviewsBy(data_storage, sk_google_reviews);
	  data_storage = applyDateFormat(sk_google_reviews, data_storage);
	  if (getDsmSetting(sk_google_reviews, "layout") == 3) {
		post_items += loadSliderLayout(sk_google_reviews, data_storage);
	  } else {
		post_items += "<div class='' style='display:block;overflow:hidden;'>";
		post_items += "<div class=' sk-ww-google-reviews-items'>";
		post_items += "<div class='sk_reviews_grid'>";
		//post_items += "<div class='sk_reviews_grid-sizer'></div>";
		if (show_average_rating == 1) {
		  post_items += getAverageRating(sk_google_reviews, data_bio);
		}
		var enable_button = false;
		last_key = parseInt(getDsmSetting(sk_google_reviews, "post_count"));
		//for (var i = 0; i < last_key; i++) {
		for (var i = 0; i < max_slides; i++) {
		  if (typeof data_storage[i] != "undefined") {
			post_items += "<div class='sk_reviews_grid-item '>";
			if (data_storage[i].review_text.length < 1) {
			  var stars = "star";
			  if (data_storage[i].rating > 1) {
				stars = "stars";
			  }
			}
			post_items += getFeedItem(data_storage[i], sk_google_reviews, data.bio);
			post_items += "</div>";
		  }
		}
		if (data_storage.length > last_key) {
		  enable_button = true;
		}
		post_items += "</div>";
		post_items += "</div>";

		post_items += "</div>";
		post_items += "</div>";
	  }
	  post_items += skGetBranding(sk_google_reviews, data.user_info);
	  sk_google_reviews.append(post_items);
	  if (getDsmSetting(sk_google_reviews, "layout") == 3) {
		sk_google_reviews.find(".swiper-slide").each(function (index, value) {
		  if (jQuery(value).text() == "") {
			jQuery(value).remove();
		  }
		});
		skSliderLayoutSettings(sk_google_reviews);
	  }
	  if (data.google_data_structure_json) {
		jQuery("head").append("<script type='application/ld+json'>" + data.google_data_structure_json + "</script>");
	  }
	  applyCustomUi(jQuery, sk_google_reviews);


	  if (getDsmSetting(sk_google_reviews, "layout") == 3) {
		setTimeout(function () {
		  applyCustomUi(jQuery, sk_google_reviews);


		}, 500);
	  }
	  addDescriptiveTagAttributes(sk_google_reviews);
	  sk_google_reviews.find(".sk_fb_date").each(function (index, value) {
		var sk_fb_date = jQuery(this).text();
		if (sk_fb_date) {
		  sk_fb_date = makeFullMonthName(sk_fb_date);
		  var translation = getDsmSetting(sk_google_reviews, "translation");
		  var translated = getDayMonthTranslation(translation, sk_fb_date);
		  jQuery(this).text(translated);
		}
	  });
	} else {
	  var sk_error_message = errorMessage();
	  sk_google_reviews.find(".first_loading_animation").hide();
	  sk_google_reviews.append(sk_error_message);
	}
	if (data.user_info) {
	  sk_increaseView(data.user_info);
	}
  }

  function getFeedItem(val, sk_google_reviews, bio) {
	var show_owners_response = getDsmSetting(sk_google_reviews, "show_owners_response");
	var show_image = getDsmSetting(sk_google_reviews, "show_image");
	var character_limit = getDsmSetting(sk_google_reviews, "character_limit");
	var see_more_text = getDsmSetting(sk_google_reviews, "see_more_text");
	see_more_text = !see_more_text ? "See more" : see_more_text;
	var post_items = "";
	var review_text = val.review_text;
	if (review_text && review_text.length - 1 > character_limit && character_limit != 0 && review_text.indexOf(" ", character_limit) != -1) {
	  review_text = review_text.substring(0, review_text.indexOf(" ", character_limit)) + " ...";
	}
	var view_on_google = sk_google_reviews.find(".custom_google_place_link").text().length > 0 ? sk_google_reviews.find(".custom_google_place_link").text() : val.reviewer_link;
	var first_character = val.reviewer_name.charAt(0);
	if (val.reviewer_photo_link && val.reviewer_photo_link.indexOf("=") != -1) {
	  var splitted_img_link = val.reviewer_photo_link.split("=");
	  splitted_img_link = splitted_img_link[1];
	  val.reviewer_photo_link = val.reviewer_photo_link.replace(splitted_img_link, "w100-h100-p-rp-mo-br40");
	}

	post_items += "<div class='sk_reviews_grid-content'>";
	post_items += "<div class='sk-ww-google-reviews-content review-list' style='text-transform: uppercase; font-size: 20px; text-align: center;'>";

	var margin_top = "";
	if (getDsmSetting(sk_google_reviews, "show_date") != 1) {
	  margin_top = "margin-top:10px;";
	}

	post_items += "<a title='"+val.reviewer_name+"' style='text-transform: uppercase; color:#ffffff !important; font-size: 20px; text-align: center; word-wrap: break-word;' href='/pages/customer-testimonials' target='_blank'><strong style='color: #ffffff !important'>" + val.reviewer_name + "</strong></a> ";
	if (getDsmSetting(sk_google_reviews, "show_date") == 1) {
	  post_items += "<div class='sk_fb_date' style='text-transform: uppercase;'>";
	  post_items += val.review_date_time;
	  post_items += "</div>";
	}

	post_items += "<div class='google-reviews-item sk-ww-google-reviews-review-text' data-link='/pages/customer-testimonials' style='font-size:22px;'>";
	post_items += "<div class='sk_fb_stars'>";
	for (var count = 1; count <= val.rating; count++) {
	  post_items += " <span aria-hidden='true'>&bigstar;</span>";
	}
	post_items += "</div>";

	post_items += review_text;


	post_items += "</div>";
	post_items += "</div>";

	post_items += "</div>";



	return post_items;
  }
  function errorMessage() {
	var sk_error_message = "";
	sk_error_message += "<ul class='sk_error_message'>";
	sk_error_message += "<li>Our system is syncing with your Google reviews, please check back later.</li>";
	sk_error_message += "<li>It usually takes only a few minutes, but might take up to 24 hours. We appreciate your patience.</li>";
	sk_error_message += "<li>We will notify you via email once your Google reviews feed is ready.</li>";
	sk_error_message += "<li>If you think there is a problem, <a title='chat support' target='_blank' href='https://go.crisp.chat/chat/embed/?website_id=2e3a484e-b418-4643-8dd2-2355d8eddc6b'>chat with support here</a>. We will solve it for you.</li>";
	sk_error_message += "</ul>";
	return sk_error_message;
  }
  function requestFeedData(sk_google_reviews) {
	var embed_id = getDsmEmbedId(sk_google_reviews);
	var json_url = app_file_server_url + embed_id + ".json?nocache=" + new Date().getTime();
	jQuery
		.getJSON(json_url, function (data) {
		  original_data = data;
		  loadFeed(sk_google_reviews);
		})
		.fail(function (e) {
		  generateSolutionMessage(sk_google_reviews, embed_id);
		});
  }

  function loadSliderLayout(sk_google_reviews, data) {
	var column_count = getColumnCount(sk_google_reviews);
	var post_items = "";
	post_items += "<div class='sk-google-all-reviews'>";
	if (data.length > 0 || getDsmSetting(sk_google_reviews, "show_average_rating") == 1 || column_count == 1) {
	  let smooth_carousel_movement = getDsmSetting(sk_google_reviews, "smooth_carousel_movement");
	  if (smooth_carousel_movement && getDsmSetting(sk_google_reviews, "autoplay") == 1) {
		smooth_carousel_movement = 1;
	  } else {
		smooth_carousel_movement = 0;
	  }
	  sk_google_reviews.find("div.smooth_carousel_movement").text(smooth_carousel_movement);
	  post_items += "<div id='sk_google_reviews_slider' class='swiper-container swiper-layout-slider'>";
	  var data_position = 0;
	  if (smooth_carousel_movement == 1) {
		post_items += '<section class="splide" aria-label="Splide Basic HTML Example" id="sk_splide">';
		post_items += '<div class="splide__track">';
		post_items += '<ul class="splide__list">';
		/*for (let index = 0; index < data.length; index++) {*/
		for (let index = 0; index < max_slides; index++) {
		  if (index == 0) {
			post_items += '<li class="splide__slide">';
			post_items += getAverageRating(sk_google_reviews, data_bio);
			post_items += "</li>";
		  }
		  post_items += '<li class="splide__slide">';
		  let val = data[index];
		  data_position++;
		  post_items += "<div class='sk_reviews_grid'>";
		  post_items += "<div class='sk_reviews_grid-item' data-position='" + data_position + "'>";
		  if (typeof val != "undefined") {
			post_items += getFeedItem(val, sk_google_reviews, data_bio);
		  }
		  post_items += "</div>";
		  post_items += "</div>";
		  post_items += "</li>";
		}
		post_items += "</ul>";
		post_items += "</div>";
		post_items += "</section>";
	  } else {

		var data_slider = data;
		var pages = Math.ceil((parseInt(data_slider.length) + 1) / column_count);
		if (pages < 1) {
		  pages = 1;
		} else if (getDsmSetting(sk_google_reviews, "show_average_rating") == 1 && (column_count == 1 || column_count == 2)) {
		  pages = pages + 1;
		}
		post_items += "<div class='swiper-wrapper'>";
		/*for (var slide = 1; slide <= pages; slide++) {*/
		for (var slide = 1; slide <= max_slides; slide++) {
		  post_items += "<div class='swiper-slide' >";
		  post_items += "<div class='sk_reviews_grid' >";
		  //post_items += "<div class='sk_reviews_grid-sizer'></div>";
		  if (getDsmSetting(sk_google_reviews, "show_badge_at_end_item") != 1 && getDsmSetting(sk_google_reviews, "show_average_rating") == 1 && slide == 1) {
			pages = pages % getDsmSetting(sk_google_reviews, "column_count") == 0 ? pages + 1 : pages;
			post_items += getAverageRating(sk_google_reviews, data_bio);
		  }
		  var slide_data = getPaginationResult(sk_google_reviews, data_slider, slide, column_count);
		  jQuery.each(slide_data, function (key, val) {
			data_position++;
			if (typeof val != "undefined") {
			  post_items += "<div class='sk_reviews_grid-item' data-position='" + data_position + "'>";
			  post_items += getFeedItem(val, sk_google_reviews, data_bio);
			  post_items += "</div>";
			}
		  });
		  if (getDsmSetting(sk_google_reviews, "show_average_rating") == 1 && slide == pages && getDsmSetting(sk_google_reviews, "show_badge_at_end_item") == 1) {
			post_items += getAverageRating(sk_google_reviews, data_bio);
		  }
		  post_items += "</div>";
		  post_items += "</div>";
		}
		post_items += "</div>";
	  }
	  post_items += "</div>";
	}
	post_items += "</div>";
	return post_items;
  }
  function getColumnCount(sk_google_reviews) {
	var column_count = getDsmSetting(sk_google_reviews, "column_count");
	column_count = parseInt(column_count);
	if (sk_google_reviews.width() < 480) {
	  column_count = 1;
	} else if (sk_google_reviews.width() <= 641) {
	  column_count = column_count > 2 ? 2 : column_count;
	} else if (sk_google_reviews.width() <= 760) {
	  column_count = column_count > 3 ? 3 : column_count;
	}
	if (sk_google_reviews.hasClass("sk-dashboard-iframe-preview") && sk_google_reviews.width() > 760) {
	  column_count = getDsmSetting(sk_google_reviews, "column_count");
	  column_count = parseInt(column_count);
	}
	sk_google_reviews.find("div.column_count").text(column_count);
	return column_count;
  }
  function getPaginationResult(sk_google_reviews, user_solutions, page, column_count) {
	if (getDsmSetting(sk_google_reviews, "show_average_rating") == 1 && page == 1 && getDsmSetting(sk_google_reviews, "show_badge_at_end_item") != 1) {
	  column_count = parseInt(column_count) - 1;
	}
	var start = 0;
	var end = parseInt(column_count);
	var multiplicand = page - 1;
	var return_user_solutions = [];
	if (page != 1) {
	  start = multiplicand * end;
	  if (getDsmSetting(sk_google_reviews, "show_average_rating") == 1 && getDsmSetting(sk_google_reviews, "show_badge_at_end_item") != 1) {
		start = start - 1;
	  }
	  end = start + end;
	}
	if (end - 1 > user_solutions.length) {
	  end = user_solutions.length;
	}
	for (var i = start; i < end; i++) {
	  return_user_solutions.push(user_solutions[i]);
	}
	return return_user_solutions;
  }
  function skSliderLayoutSettings(sk_google_reviews) {
	var embed_id = sk_google_reviews.attr("data-embed-id");
	var loop = false;
	var speed = 500;
	var freeMode = false;
	var autoplay = false;
	var delay = parseInt(getDsmSetting(sk_google_reviews, "delay"));
	if (getDsmSetting(sk_google_reviews, "autoplay") == 1) {
	  var delay = delay * 1500;
	  autoplay = { delay: delay };
	  loop = true;
	}
	if (getDsmSetting(sk_google_reviews, "smooth_carousel_movement") == 1) {
	  splide = new Splide("#sk_splide", { type: "loop", drag: "free", focus: "center", perPage: 2, autoScroll: { speed: 4 }, autoStart: false, autoplay: false });
	  splide.mount(window.splide.Extensions);
	  sk_google_reviews.find(".sk_reviews_grid").css({ width: "100%", transition: "transform 0.3s ease" });
	  sk_google_reviews.find(".sk_reviews_grid").hover(
		  function () {
			/*jQuery(this).css("transform", "scale(1.03)");*/
		  },
		  function () {
			/*jQuery(this).css("transform", "scale(1)");*/
		  }
	  );
	  sk_google_reviews.find(".splide__pagination, .splide__arrow").css("display", "none");

	} else {
	  var swiper = new Swiper('.sk-ww-google-reviews[data-embed-id="' + embed_id + '"] .swiper-layout-slider.swiper-container', {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: loop,
		autoplay: autoplay,
		freeMode: freeMode,
		speed: speed,
		freeModeMomentum: false,
		navigation: { nextEl: '.sk-ww-google-reviews[data-embed-id="' + embed_id + '"] .swiper-button-next', prevEl: '.sk-ww-google-reviews[data-embed-id="' + embed_id + '"] .swiper-button-prev' },
		on: {
		  slideNextTransitionStart: function () {
			if (jQuery(document).width() < 520) {
			  alignSwiperButtons(sk_google_reviews);
			}
		  },
		  slidePrevTransitionStart: function () {
			if (jQuery(document).width() < 520) {
			  alignSwiperButtons(sk_google_reviews);
			}
		  },
		},
	  });
	}
  }
  function skLayoutSliderArrowUI(sk_google_reviews) {
	var arrow_background_color = getDsmSetting(sk_google_reviews, "arrow_background_color");
	var arrow_color = getDsmSetting(sk_google_reviews, "arrow_color");
	var arrow_opacity = getDsmSetting(sk_google_reviews, "arrow_opacity");
	sk_google_reviews
		.find(".swiper-button-prev i,.swiper-button-next i")
		.mouseover(function () {
		  jQuery(this).css({ opacity: "1", "border-color": arrow_background_color });
		})
		.mouseout(function () {
		  jQuery(this).css({ "border-color": arrow_color, opacity: arrow_opacity });
		});
	sk_google_reviews.find(".swiper-button-prev i,.swiper-button-next i").css({ "border-color": arrow_color, opacity: arrow_opacity, color: arrow_color });
	sk_google_reviews.find(".swiper-button-spinner").css({ color: arrow_color });
	var feed_h = sk_google_reviews.find(".swiper-slide-active .sk_reviews_grid").innerHeight();
	if (feed_h == null) {
	  feed_h = sk_google_reviews.find(".sk_reviews_grid").innerHeight();
	}
	sk_google_reviews.find(".swiper-wrapper,.swiper-slide,.swiper-layout-slider").css({ height: feed_h + "px" });
	sk_google_reviews.css("width", "100%");
	var feed_h_2 = feed_h / 2;
	sk_google_reviews.find(".swiper-button-prev,.swiper-button-next").css({ top: feed_h_2 + "px" });
	if (jQuery(document).width() < 520) {
	  alignSwiperButtons(sk_google_reviews);
	}
	applyFooterStyle(sk_google_reviews);
  }
  function alignSwiperButtons(sk_google_reviews) {
	if (isSafariBrowser()) {
	  var badge = jQuery(".swiper-slide-active .sk_reviews_grid").find(".badge-content");
	  var right = 3;
	  var left = -14;
	  sk_google_reviews.find(".swiper-button-next").attr("style", "right: " + right + "px !important");
	  sk_google_reviews.find(".swiper-button-prev").attr("style", "left: -" + left + "px !important");
	}
  }


  function makeResponsive(jQuery, sk_google_reviews) {
	var sk_google_reviews_width = sk_google_reviews.width();
	var grid_sizer_item = 33.33;
	var column_count = getDsmSetting(sk_google_reviews, "column_count");
	var chronical = jQuery('link[rel="canonical"]').attr("href");
	if (chronical && chronical.indexOf("healthy-pet-aurora-illinois") != -1) {
	  sk_google_reviews_width = jQuery(document).width();
	}
	if (sk_google_reviews_width <= 320) {
	  grid_sizer_item = 100;
	} else if (sk_google_reviews_width <= 481) {
	  grid_sizer_item = 100;
	} else if (sk_google_reviews_width <= 641) {
	  grid_sizer_item = 50;
	  if (column_count == 1) {
		grid_sizer_item = 100;
	  }
	} else if (sk_google_reviews_width <= 930) {
	  if (getDsmSetting(sk_google_reviews, "column_count") == 1) {
		grid_sizer_item = 100;
	  } else if (getDsmSetting(sk_google_reviews, "column_count") == 2) {
		grid_sizer_item = 50;
	  } else if (getDsmSetting(sk_google_reviews, "column_count") == 4) {
		grid_sizer_item = 25;
	  } else if (getDsmSetting(sk_google_reviews, "column_count") == 5) {
		grid_sizer_item = 20;
	  } else if (getDsmSetting(sk_google_reviews, "column_count") == 6) {
		grid_sizer_item = 16.6;
	  } else {
		grid_sizer_item = 33.33;
	  }
	} else {
	  if (column_count == 1) {
		grid_sizer_item = 100;
	  } else if (column_count == 2) {
		grid_sizer_item = 50;
	  } else if (column_count == 3) {
		grid_sizer_item = 33.33;
	  } else if (column_count == 4) {
		grid_sizer_item = 25;
	  } else if (column_count == 5) {
		grid_sizer_item = 20;
	  } else if (column_count == 6) {
		grid_sizer_item = 16.6;
	  }
	}
	//sk_google_reviews.find(".sk_reviews_grid-sizer,.sk_reviews_grid-item").css({ width: grid_sizer_item + "%" });
	var imgs = sk_google_reviews.find("img");
	var len = imgs.length;
	if (getDsmSetting(sk_google_reviews, "layout") == 3) {
	  setReviewsFeedHeight(sk_google_reviews, true);
	  skLayoutSliderArrowUI(sk_google_reviews);
	} else if (getDsmSetting(sk_google_reviews, "layout") == 1) {
	  setReviewsFeedHeight(sk_google_reviews, true);
	}
	if (len == 0 || imgs.prop("complete")) {
	  setTimeout(function () {
		if (getDsmSetting(sk_google_reviews, "layout") == 3) {
		  skLayoutSliderArrowUI(sk_google_reviews);
		}
	  }, 50);
	}
	var counter = 0;
	[].forEach.call(imgs, function (img) {
	  img.addEventListener(
		  "load",
		  function () {
			counter++;
			if (counter + 1 == len) {
			  if (getDsmSetting(sk_google_reviews, "layout") == 3) {
				skLayoutSliderArrowUI(sk_google_reviews);
			  } else if (getDsmSetting(sk_google_reviews, "layout") == 1) {
				setReviewsFeedHeight(sk_google_reviews, true);
			  }
			}
		  },
		  false
	  );
	});
	if (getDsmSetting(sk_google_reviews, "layout") != 2) {
	  applyFooterStyle(sk_google_reviews);
	}
  }
  function applyFooterStyle(sk_google_reviews) {
	var bottom = parseInt(getDsmSetting(sk_google_reviews, "item_content_padding"));
	if (sk_google_reviews.width() < 480) {
	  bottom = 20;
	}
	if (getDsmSetting(sk_google_reviews, "show_view_on_google_button") == 1) {
	  sk_google_reviews.find(".sk-ww-google-reviews-content-container .sk-google-review-button-more").css({ position: "absolute", bottom: bottom + "px" });
	  sk_google_reviews.find(".sk-ww-google-reviews-review-text").css({ "text-align": "center", "margin-bottom": bottom + "px" });
	}
  }
  function hoverContent(sk_google_reviews) {
	sk_google_reviews
		.find(".badge-content, .sk-ww-google-reviews-review-text")
		.mouseover(function () {
		  var container_height = sk_google_reviews.find(".sk-ww-google-reviews-content").height();
		  if (jQuery(this).height() < container_height) {
			jQuery(this).css({ "overflow-y": "auto", "overflow-x": "hidden" });
		  }
		})
		.mouseout(function () {
		  jQuery(this).css({ "overflow-y": "hidden" });
		});
	sk_google_reviews.find(".sk-ww-google-reviews-review-text-content, .sk-ww-google-reviews-owners-response-image").css({ width: "100%" });
	sk_google_reviews.find(".sk-ww-google-reviews-owners-response-text").css({ width: "100%" });
	setTimeout(function () {
	  sk_google_reviews.find(".sk-ww-google-reviews-review-text-content, .sk-ww-google-reviews-owners-response-image").css({ width: "100%" });
	  sk_google_reviews.find(".sk-ww-google-reviews-owners-response-text").css({ width: "100%" });
	}, 1000);
  }
  function setReviewsFeedHeight(sk_google_reviews, change) {
	jQuery(document).ready(function () {
	  var thisH = 0;
	  var post_height = getDsmSetting(sk_google_reviews, "post_height");
	  if (post_height == 0) {
		post_height = 350;
	  }
	  post_height = parseInt(post_height);
	  sk_google_reviews.find(".sk_reviews_badge,.google-reviews-item").css({ height: "auto" });
	  sk_google_reviews.find(".sk-ww-google-reviews-content").css({ height: "100%" });
	  var badgeContent = sk_google_reviews.find(".badge-content");
	  var maxHeight = jQuery(badgeContent).height();
	  if (post_height < maxHeight) {
		post_height = maxHeight;
	  }
	  var padding_ = parseInt(getDsmSetting(sk_google_reviews, "item_content_padding"));
	  sk_google_reviews.find(".sk_reviews_grid-content").css({ height: parseInt(post_height) + padding_ + "px" });
	  hoverContent(sk_google_reviews);
	  jQuery(".sk-ww-google-reviews-content").each(function () {
		var main_h = post_height - padding_ * 2 + 10;
		var header = jQuery(this).find(".sk-ww-google-reviews-content review-list").height();
		var body = jQuery(this).find(".sk-ww-google-reviews-content review-list").height();
		var footer = jQuery(this).find(".sk-google-review-button-more").height();
		var view_on_google_btn_height = sk_google_reviews.find(".sk-google-review-button-more").height();
		footer = footer ? footer : 0;
		var final = main_h - header - footer - 20;
		jQuery(this)
			.find(".badge-content, .sk-ww-google-reviews-review-text")
			.css({ height: final + "px", overflow: "hidden" });
	  });
	});
  }
  function applyCustomUi(jQuery, sk_google_reviews) {
	sk_google_reviews.find(".loading-img").hide();
	sk_google_reviews.find(".first_loading_animation").hide();
	sk_google_reviews.css({ width: "100%" });
	var sk_google_reviews_width = sk_google_reviews.outerWidth(true).toFixed(2);
	sk_google_reviews.css({ height: "auto" });
	var column_count = sk_google_reviews.find(".column_count").text();
	if (sk_google_reviews_width <= 320 || sk_google_reviews_width <= 481 || sk_google_reviews_width <= 641) {
	  if (column_count > 1) {
		column_count = 2;
	  }
	}
	if (sk_google_reviews.hasClass("sk-dashboard-iframe-preview") && sk_google_reviews_width > 760) {
	  column_count = getDsmSetting(sk_google_reviews, "column_count");
	  column_count = parseInt(column_count);
	}
	var border_size = 0;
	var background_color = "#555555";
	var space_between_images = parseFloat(sk_google_reviews.find(".space_between_images").text());
	var margin_between_images = parseFloat(parseFloat(space_between_images).toFixed(0) / 2) - parseFloat(1);
	var total_space_between_images = parseFloat(space_between_images).toFixed(2) * parseFloat(column_count) + parseFloat(space_between_images);
	var pic_width = (parseFloat(sk_google_reviews_width).toFixed(0) - parseFloat(total_space_between_images).toFixed(0)) / parseFloat(column_count).toFixed(0);
	sk_google_reviews.css({ width: "100%" });
	var sk_google_reviews_width = sk_google_reviews.outerWidth(true).toFixed(2);
	sk_google_reviews.css({ height: "auto" });
	var column_count = sk_google_reviews.find(".column_count").text();
	var border_size = 0;
	var background_color = "#555555";
	var space_between_images = parseFloat(sk_google_reviews.find(".space_between_images").text());
	var margin_between_images = parseFloat(parseFloat(space_between_images).toFixed(0) / 2) - parseFloat(1);
	var total_space_between_images = parseFloat(space_between_images).toFixed(2) * parseFloat(column_count) + parseFloat(space_between_images);
	var pic_width = (parseFloat(sk_google_reviews_width).toFixed(0) - parseFloat(total_space_between_images).toFixed(0)) / parseFloat(column_count).toFixed(0);
	var font_family = sk_google_reviews.find(".font_family").text();
	var details_bg_color = sk_google_reviews.find(".details_bg_color").text();
	var details_link_color = sk_google_reviews.find(".details_link_color").text();
	var details_link_hover_color = sk_google_reviews.find(".details_link_hover_color").text();
	var bold_font_color = sk_google_reviews.find(".bold_font_color").text();
	var item_bg_color = sk_google_reviews.find(".item_bg_color").text();
	var item_font_color = sk_google_reviews.find(".item_font_color").text();
	var badge_bg_color = sk_google_reviews.find(".badge_bg_color").text();
	var badge_font_color = sk_google_reviews.find(".badge_font_color").text();
	var button_bg_color = sk_google_reviews.find(".button_bg_color").text();
	var button_text_color = sk_google_reviews.find(".button_text_color").text();
	var button_hover_bg_color = sk_google_reviews.find(".button_hover_bg_color").text();
	var button_hover_text_color = sk_google_reviews.find(".button_hover_text_color").text();
	sk_google_reviews.css({ "font-family": "Source Sans Pro,sans-serif", "background-color": details_bg_color, width: sk_google_reviews_width });
	jQuery(".sk-pop-google-videos-post").css({ "font-family": "Source Sans Pro,sans-serif" });
	sk_google_reviews.find(".sk-ww-google-reviews-review-text-content div").css({ "font-family": "Source Sans Pro,sans-serif" });
	sk_google_reviews.find(".google-videos-user-root-container a, .sk-ww-google-reviews-content a").css({ color: details_link_color });
	sk_google_reviews
		.find(".google-videos-user-root-container a, .sk-ww-google-reviews-content a")
		.mouseover(function () {

		})
		.mouseout(function () {

		});
	sk_google_reviews.find(".sk-ww-google-reviews-owners-response-text strong").css({ color: bold_font_color });
	sk_google_reviews.find(".sk-ww-google-reviews-review-text, .sk-ww-google-reviews-owners-response-text, .sk-ww-google-reviews-content label").css({ color: item_font_color });
	sk_google_reviews.find(".sk-review-popup").css({ color: item_font_color, "font-family": "Source Sans Pro,sans-serif" });
	sk_google_reviews.find(".sk-ww-google-reviews-review-text, .sk-ww-google-reviews-owners-response-text, .sk-ww-google-reviews-content review-list").css({ "font-size": "20px", "text-align": "center", "text-transform": "uppercase" });
	sk_google_reviews.find(".sk-google-reviews-badge-info").css({ "font-size": getDsmSetting(sk_google_reviews, "title_font_size") + "px" });
	if (getDsmSetting(sk_google_reviews, "details_all_caps") == 1) {
	  sk_google_reviews
		  .find(".sk-google-review-button-more, .sk-review-popup, .sk-ww-google-reviews-review-text, .sk-ww-google-reviews-owners-response-text, .sk-ww-google-reviews-content review-list, .sk_reviews_badge")
		  .css({ "text-transform": "uppercase" });
	}
	if (getDsmSetting(sk_google_reviews, "title_all_caps") == 1) {
	  sk_google_reviews.find(".sk-google-place-name").css({ "text-transform": "uppercase" });
	} else {
	  sk_google_reviews.find(".sk-google-place-name").css({ "text-transform": "none" });
	}
	sk_google_reviews.find(".sk-google-reviews-badge-info, .sk-ww-google-reviews-content, .sk-google-reviews-badge-info, .sk-review-popup").css({ padding: getDsmSetting(sk_google_reviews, "item_content_padding") + "px" });
	sk_google_reviews.find(".sk-ww-google-reviews-owners-response-image").css({ "padding-bottom": getDsmSetting(sk_google_reviews, "item_content_padding") + "px" });
	sk_google_reviews.find(".sk_reviews_num_icon").css({ "background-color": "transparent", color: badge_font_color });
	sk_google_reviews.find(".sk_reviews_badge").css({ "border-color": badge_bg_color });
	var margin_bottom_sk_ig_load_more_posts = space_between_images;
	if (margin_bottom_sk_ig_load_more_posts == 0) {
	  margin_bottom_sk_ig_load_more_posts = 5;
	}
	sk_google_reviews.find(".sk-google-reviews-load-more-posts").css({ "margin-bottom": margin_bottom_sk_ig_load_more_posts + "px" });
	sk_google_reviews.find(".sk-below-button-container").css({ display: "block", overflow: "hidden", margin: "0", padding: "4.5px" });
	sk_google_reviews
		.find(".google-videos-user-container, .sk-google-reviews-load-more-posts, .sk-google-reviews-bottom-follow-btn")
		.css({ "background-color": button_bg_color, "border-color": button_bg_color, color: button_text_color });
	sk_google_reviews
		.find(".google-videos-user-container, .sk-google-reviews-load-more-posts, .sk-google-reviews-bottom-follow-btn")
		.mouseover(function () {
		})
		.mouseout(function () {
		});
	var padding_sk_ig_bottom_btn_container = margin_between_images;
	if (padding_sk_ig_bottom_btn_container == 0) {
	  padding_sk_ig_bottom_btn_container = 5;
	}
	sk_google_reviews.find(".sk-google-reviews-bottom-btn-container").css({ padding: padding_sk_ig_bottom_btn_container + "px" });
	sk_google_reviews.find(".sk_fb_stars").css({ color: "#ffffff" });
	sk_google_reviews.find(".sk_fb_stars span").css({ color: "#ffffff" });
	sk_google_reviews.find(".sk_reviews_badge a").css({ color: "#ffffff" });
	sk_google_reviews
		.find(".sk-google-reviews-write-review-btn")
		.css({ color: getDsmSetting(sk_google_reviews, "write_a_review_button_text_color"), "background-color": getDsmSetting(sk_google_reviews, "write_a_review_button_background_color") });
	sk_google_reviews
		.find(".sk-google-reviews-write-review-btn")
		.mouseover(function () {

		})
		.mouseout(function () {

		});
	sk_google_reviews
		.find(".sk_reviews_grid-content")
		.css({ "background-color": item_bg_color, color: getDsmSetting(sk_google_reviews, "item_font_color"), "border-radius": getDsmSetting(sk_google_reviews, "item_border_radius") + "px" });
	sk_google_reviews.find(".sk_reviews_grid-item").css({ cursor: "pointer" });
	makeResponsive(jQuery, sk_google_reviews);
	if (
		getDsmSetting(sk_google_reviews, "one_column_layout") == 1 ||
		(getDsmSetting(sk_google_reviews, "layout") == 3 && getDsmSetting(sk_google_reviews, "smooth_carousel_movement") == 1 && getDsmSetting(sk_google_reviews, "autoplay") == 1)
	) {
	  sk_google_reviews.find(".sk_reviews_grid-item").css({ width: "100%" });
	}
	if (getDsmSetting(sk_google_reviews, "layout") == 2 && sk_google_reviews_width < 541) {
	  sk_google_reviews.find(".sk-ww-google-reviews-review-text").css({ overflow: "hidden" });
	}
	if (getDsmSetting(sk_google_reviews, "layout") == 3) {
	  skLayoutSliderArrowUI(sk_google_reviews);
	}
	sk_google_reviews.find(".badge-content").css({ "background-color": badge_bg_color, color: badge_font_color });

	var custom_css = getDsmSetting(sk_google_reviews, "custom_css") + " .sk_branding{ display : block !important; } .sk_branding a{ display : block !important; }";
	jQuery("head").append('<style type="text/css">' + custom_css + "</style>");
	/*var href = window.location.href;*/

	apply100PercentWidth(sk_google_reviews, sk_google_reviews_width);
	applyBadgeStyle(sk_google_reviews);
	applyPopUpColors(sk_google_reviews);

	if (jQuery(".sk-ww-google-reviews").length == 1 && jQuery(".sk-google-all-reviews").length > 1) {
	  jQuery(".sk-google-all-reviews").first().remove();
	}
	sk_google_reviews.closest(".section-fit").find(".item-absolute").css({ width: "100%", left: "0px" });
  }
  function applyBadgeStyle(sk_google_reviews) {
	sk_google_reviews.find(".sk_reviews_badge_container .sk-badge-name").css({ "background-color": "transparent", color: getDsmSetting(sk_google_reviews, "badge_font_color") });
	sk_google_reviews
		.find(".sk_reviews_badge_container .sk-badge-name")
		.find("div, .sk-google-reviews-badge-info")
		.css({ "background-color": "transparent", color: getDsmSetting(sk_google_reviews, "badge_font_color") });
  }
  function apply100PercentWidth(sk_google_reviews, sk_google_reviews_width) {
	var grid_item = sk_google_reviews.find(".sk_reviews_grid-item");
	var length = grid_item.length;
	if (length > 1) {
	  sk_google_reviews.find(".sk-below-button-container").css({ width: (sk_google_reviews_width > 640 ? sk_google_reviews_width - 11 : sk_google_reviews_width) + "px" });
	}
	if (length == 1) {
	  grid_item.css("width", "100%");
	}
  }
  function applyPopUpColors(sk_google_reviews) {
	var pop_up_bg_color = getDsmSetting(sk_google_reviews, "pop_up_bg_color");
	var pop_up_font_color = getDsmSetting(sk_google_reviews, "pop_up_font_color");
	var pop_up_link_color = getDsmSetting(sk_google_reviews, "pop_up_link_color");
	sk_google_reviews.find(".sk-review-popup").css({ color: pop_up_font_color, background: pop_up_bg_color });
	sk_google_reviews.find(".sk-review-popup a").css({ color: pop_up_link_color });
  }

  function addDescriptiveTagAttributes(_sk, add_to_img = true) {
	_sk.find("a").each(function (i, v) {
	  var title = jQuery(v).text();
	  jQuery(v).attr("title", title);
	});

  }

  function setCookieSameSite() {
	document.cookie = "AC-C=ac-c;expires=Fri, 31 Dec 2025 23:59:59 GMT;path=/;HttpOnly;SameSite=Lax";
  }
  setCookieSameSite();
  function getIEVersion() {
	var sAgent = window.navigator.userAgent;
	var Idx = sAgent.indexOf("MSIE");
	if (Idx > 0) return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
	else if (!!navigator.userAgent.match(/Trident\/7\./)) return 11;
	else return 0;
  }
  function isSafariBrowser() {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.indexOf("safari") != -1) {
	  if (ua.indexOf("chrome") > -1) {
		return 0;
	  } else {
		return 1;
	  }
	}
  }


  function sk_increaseView(user_info) {

  }

  function skGetEnvironmentUrls(folder_name) {
	var scripts = document.getElementsByTagName("script");
	var scripts_length = scripts.length;
	var search_result = -1;
	var other_result = -1;
	var app_url = "https://widgets.sociablekit.com/";
	var app_backend_url = "https://api.accentapi.com/v1/";
	var app_file_server_url = "https://data.accentapi.com/feed/";
	var sk_app_url = "https://sociablekit.com/app/";
	var sk_api_url = "https://api.sociablekit.com/";
	var sk_img_url = "https://images.sociablekit.com/";
	for (var i = 0; i < scripts_length; i++) {
	  var src_str = scripts[i].getAttribute("src");
	  if (src_str != null) {
		var other_folder = "";
		other_result = src_str.search(other_folder);
		search_result = src_str.search(folder_name);
		app_url = "https://widgets.sociablekit.com/";
	  }

	}
	return { app_url: app_url, app_backend_url: app_backend_url, app_file_server_url: app_file_server_url, sk_api_url: sk_api_url, sk_app_url: sk_app_url, sk_img_url: sk_img_url };
  }

  function skGetBranding(sk_, user_info) {
	sk_.find(".sk_branding").remove();
	sk_.find("div.user_email").remove();
	var html = "";
	return html;
  }

  function widgetValidation(_sk, data) {
	if (data.user_info) {
	  var user_info = data.user_info;
	  user_info.trial_ended = false;
	  if (user_info.status == 7 && user_info.cancellation_date) {
		var cancellation_date = new Date(user_info.cancellation_date).setHours(0, 0, 0, 0);
		var current_date = new Date().setHours(0, 0, 0, 0);
		user_info.show_feed = current_date > cancellation_date ? false : true;
		var activation_date = new Date(user_info.activation_date).setHours(0, 0, 0, 0);
		if (activation_date > cancellation_date) {
		  user_info.show_feed = true;
		}
	  } else if (user_info.status == 0 || user_info.status == 2 || user_info.status == 10) {
		user_info.show_feed = false;
	  }
	  if (user_info.type == 43 || user_info.type == 38) {
		var sk_error_message = generateBlueMessage(_sk, user_info);
		_sk.find(".first_loading_animation").hide();
		_sk.html(sk_error_message);
	  }
	  if (!user_info.show_feed) {
		var sk_error_message = generateBlueMessage(_sk, user_info);
		_sk.find(".first_loading_animation").hide();
		_sk.html(sk_error_message);
	  }
	  return user_info.show_feed;
	}
  }


  function getDayMonthTranslation(translation, replace) {
	if (translation == "English - US" || translation == "English - UK") {
	  return getEnglishDayMonth(replace);
	} else {
	  return replace;
	}
  }
  function getEnglishDayMonth(replace) {
	return replace;
  }

  function str_replace(to_replace, replacement, original) {
	var res = original;
	if (res) {
	  res = res.split(to_replace).join(replacement);
	}
	return res;
  }
  function makeFullMonthName(replace) {
	replace = str_replace("Jan ", "January ", replace);
	replace = str_replace("JAN ", "January ", replace);
	replace = str_replace("Feb ", "February ", replace);
	replace = str_replace("FEB ", "February ", replace);
	replace = str_replace("Mar ", "March ", replace);
	replace = str_replace("MAR ", "March ", replace);
	replace = str_replace("Apr ", "April ", replace);
	replace = str_replace("APR ", "April ", replace);
	replace = str_replace("May ", "May ", replace);
	replace = str_replace("MAY ", "May ", replace);
	replace = str_replace("Jun ", "June ", replace);
	replace = str_replace("JUN ", "June ", replace);
	replace = str_replace("Jul ", "July ", replace);
	replace = str_replace("JUL ", "July ", replace);
	replace = str_replace("Aug ", "August ", replace);
	replace = str_replace("AUG ", "August ", replace);
	replace = str_replace("Sep ", "September ", replace);
	replace = str_replace("SEP ", "September ", replace);
	replace = str_replace("Oct ", "October ", replace);
	replace = str_replace("OCT ", "October ", replace);
	replace = str_replace("Nov ", "November ", replace);
	replace = str_replace("NOV ", "November ", replace);
	replace = str_replace("Dec ", "December ", replace);
	replace = str_replace("DEC ", "December ", replace);
	return replace;
  }

  function main() {
	function loadSettingsData(sk_google_reviews, json_settings_url, json_feed_url) {
	  fetch(json_feed_url, { method: "get" })
		  .then(function (response) {
			if (!response.ok) {
			  loadSettingsData(sk_google_reviews, json_settings_url, json_settings_url);
			  return;
			}
			response.json().then(function (data) {
			  if (window.location.href.includes("66348024067")) {
				sk_google_reviews.parent("div").width(jQuery("body").width());
			  }
			  var settings_data = data;
			  original_data = data;
			  if (data.settings) {
				settings_data = data.settings;
				settings_data.type = 22;
			  }
			  if (!settings_data.type) {
				loadSettingsData(sk_google_reviews, json_settings_url, json_settings_url);
				return;
			  }
			  settings_data.type = 22;

			  if (settings_data.show_feed == false) {
				sk_google_reviews.find(".loading-img").hide();
				sk_google_reviews.prepend(settings_data.message);
			  } else {
				var settings_html = "";
				settings_html += "<div class='sk-settings' style='content-visibility: hidden;'>";
				jQuery.each(settings_data, function (key, value) {
				  if(value != null || value != ""){
					settings_html += "<div class='" + key + "'>" + value + "</div>";
				  }
				});
				settings_html += "</div>";
				sk_google_reviews.prepend(settings_html);

				if (getDsmSetting(sk_google_reviews, "layout") == 3) {
				  loadCssFile(app_url + "libs/swiper/swiper.min.css");
				  loadCssFile(app_url + "libs/swiper/swiper.css?v=ranndomchars");
				}
				if (data.css) {
				  jQuery("head").append('<style type="text/css">' + data.css + "</style>");
				} else {
				  var sk_version = settings_data.sk_version ? settings_data.sk_version : 1.0;
				  loadCssFile(app_url + "google-reviews/styles.css?v=" + sk_version);
				}
				settings_html = "";
				if (getDsmSetting(sk_google_reviews, "layout") == 3) {
				  if (getDsmSetting(sk_google_reviews, "smooth_carousel_movement") == 1 && getDsmSetting(sk_google_reviews, "autoplay") == 1) {
					var currentURL = window.location.href;

					if (data.settings) {
					  loadFeed(sk_google_reviews);
					} else {
					  requestFeedData(sk_google_reviews);
					}

				  } else {
					loadScript("//www.bulletproofhitches.com/cdn/shop/t/69/assets/swiper.js?v=99471501926389132101763135545", function() {
					  if (data.settings) {
						loadFeed(sk_google_reviews);
					  } else {
						requestFeedData(sk_google_reviews);
					  }
					});
				  }
				} else {
				  if (data.settings) {
					loadFeed(sk_google_reviews);
				  } else {
					requestFeedData(sk_google_reviews);
				  }
				}
			  }
			});

		  })
		  .catch(function (err) {
			loadSettingsData(sk_google_reviews, json_settings_url, json_settings_url);
		  });
	}
	jQuery(document).ready(function ($) {
	  if (jQuery.find('div[data-embed-id="142714"]').length > 1) {
		var script_src = jQuery(jQuery('script[src="https://widgets.sociablekit.com/google-reviews/widget.js"]')[1]);
		if (script_src) {
		  script_src.remove();
		  jQuery.find('div[data-embed-id="142714"]')[1].remove();
		}
	  }
	  if (jQuery.find('div[data-embed-id="106598"]').length > 1) {
		jQuery("div.showMobile2Theme").remove();
		jQuery(".sk-ww-google-reviews").each(function (index) {

		});
	  } else {
		jQuery(".sk-ww-google-reviews").each(function () {
		  var sk_google_reviews = jQuery(this);
		  sk_google_reviews.closest("div#custom-html-d").attr("id", "custom-html-div");
		  var embed_id = getDsmEmbedId(sk_google_reviews);
		  var new_sk_google_reviews_height = jQuery(window).height() + 100;
		  sk_google_reviews.height(new_sk_google_reviews_height);
		  var json_settings_url = app_file_server_url.replace("feed", "") + "settings/" + embed_id + "/settings.json?nocache=" + new Date().getTime();
		  var json_feed_url = app_file_server_url + embed_id + ".json?nocache=" + new Date().getTime();
		  loadSettingsData(sk_google_reviews, json_settings_url, json_feed_url);
		});
	  }
	  jQuery(window).resize(function () {

	  });
	  jQuery(document).on("click", ".swiper-prev-arrow,.swiper-next-arrow", function () {

	  });
	  jQuery(document).on("click", ".prev_sk_google_review", function () {
		var clicked_element = jQuery(this);
		clicked_element.html("<i class='fa fa-spinner fa-pulse' aria-hidden='true'></i>");
		var new_clicked_element = jQuery(".sk_selected_reviews").prev(".sk_reviews_grid-item");
		var content_src = new_clicked_element.find(".sk-review-popup");

	  });
	  jQuery(document).on("click", ".next_sk_google_review", function () {
		var clicked_element = jQuery(this);
		clicked_element.html("<i class='fa fa-spinner fa-pulse' aria-hidden='true'></i>");
		var new_clicked_element = jQuery(".sk_selected_reviews").next(".sk_reviews_grid-item");
		var content_src = new_clicked_element.find(".sk-review-popup");

	  });
	  jQuery(document).on("click", ".google-reviews-item", function () {
		var clicked_element = jQuery(this).closest(".sk_reviews_grid-item");
		var content_src = clicked_element.find(".sk-review-popup");
		var sk_google_reviews = clicked_element.closest(".sk-ww-google-reviews");
		if (getDsmSetting(sk_google_reviews, "show_reviews_on_new_tab") == 1 && getDsmSetting(sk_google_reviews, "links_clickable") == 1) {
		  var url = jQuery(this).attr("data-link");
		  window.open(url, "_blank");
		} else if (getDsmSetting(sk_google_reviews, "show_reviews_on_new_tab") == 0) {
		  if (content_src.length > 0 && clicked_element.length > 0) {

		  }
		}
	  });
	  jQuery(document).on("click", ".sk-google-reviews-load-more-posts", function () {
		if (jQuery(this).attr("disabled") == "disabled") {
		  return false;
		}
		jQuery(this).attr("disabled", "disabled");
		var current_btn = jQuery(this);
		var current_btn_text = current_btn.text();
		var sk_google_reviews = jQuery(this).closest(".sk-ww-google-reviews");
		jQuery(this).html("<i class='fa fa-spinner fa-pulse' aria-hidden='true'></i>");
		var post_items = "";
		setTimeout(function () {
		  var enable_button = false;
		  var old_last_key = last_key;
		  last_key = old_last_key + parseInt(getDsmSetting(sk_google_reviews, "post_count"));
		  //for (var i = old_last_key; i < last_key; i++) {
		  for (var i = 1; i < 10; i++) {
			if (typeof data_storage[i] != "undefined") {
			  post_items += "<div class='sk_reviews_grid-item'>";
			  post_items += getFeedItem(data_storage[i], sk_google_reviews, data_bio);
			  post_items += "</div>";
			}
		  }
		  if (data_storage.length > 10) {
			enable_button = true;
		  }
		  sk_google_reviews.find(".sk_reviews_grid").append(post_items);
		  if (enable_button) {
			current_btn.html(current_btn_text);
			current_btn.show();
		  } else {
			current_btn.hide();
		  }
		  current_btn.removeAttr("disabled");
		  applyCustomUi(jQuery, sk_google_reviews);



		}, 1500);
	  });
	  jQuery(document).on("click", ".sk-ww-google-reviews .sk-watermark", function () {
		jQuery(".sk-ww-google-reviews .sk-message").slideToggle();
	  });
	});
  }
})(window, document);
